module.exports = "<section class=\"banner-landing v1\">\r\n    <div class=\"container\">\r\n        <!-- <div ng-bind-html=\"$ctrl.shCtrl.globalParams.cmsInfo.BIENVENIDA | toTrusted\" ></div> -->\r\n        <advertisement  ng-if=\"$ctrl.cmsData.espacios[1]\"  sh-ctrl=\"$ctrl.shCtrl\" type-content=\"espacios\" positions=\"1\" content-data=\"$ctrl.cmsData\"></advertisement>\r\n    </div>\r\n</section>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/landing/templates/landing-t1.view.html
 ** module id = 640
 ** module chunks = 0
 **/